var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLorryOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lorry-outline_svg__clip0_1_22789)",
    stroke: "#2355FC",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.331 11.997V4a1.333 1.333 0 00-1.333-1.333H2.666a1.333 1.333 0 00-1.333 1.333v7.332a.667.667 0 00.667.666h1.333M9.998 11.997h-4M12.664 11.997h1.333a.666.666 0 00.666-.666V8.898a.667.667 0 00-.146-.416l-2.32-2.9a.666.666 0 00-.52-.25H9.331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.33 13.33a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666zM4.666 13.33a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lorry-outline_svg__clip0_1_22789"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15.996v15.996H0z"
  })))));
}

export default SvgLorryOutline;